import { render, staticRenderFns } from "./DamageStatusProgress.vue?vue&type=template&id=00f6678d"
import script from "./DamageStatusProgress.vue?vue&type=script&lang=ts"
export * from "./DamageStatusProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports